/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Add: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="add" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1190 623.3475000000001H736.6524999999999V170H623.305V623.3475000000001H169.9575V736.695H623.305V1190.0425H736.6524999999999V736.695H1190V623.3475000000001z" : "M952 498.6780000000001H589.3219999999999V136H498.6439999999999V498.6780000000001H135.966V589.356H498.6439999999999V952.0340000000002H589.3219999999999V589.356H952V498.6780000000001z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Add.displayName = `Blueprint5.Icon.Add`;
export default Add;
